import React from 'react'
import { TrackedButton } from './AnalyticsEvents'

type IconProps = { onClick?: () => void, active?: boolean, title?: string }

const selected = 'selected'
const notSelected = ''

export const Check: React.FC<IconProps> = ({ active = false, onClick, title }) => 
    <TrackedButton event='Check' onClick={onClick} ><i className={`fas fa-check-circle ${active ? selected : notSelected}`} title={title}></i></TrackedButton>

export const Cross: React.FC<IconProps> = ({ active = false, onClick, title }) => 
    <TrackedButton event='Cross' onClick={onClick} ><i className={`fas fa-times-circle ${active ? selected : notSelected}`} title={title}></i></TrackedButton>

export const Award: React.FC<IconProps> = ({ active = false, onClick, title }) => 
    <TrackedButton event='Award' onClick={onClick} ><i className={`fas fa-award ${active ? selected : notSelected}`} title={title}></i></TrackedButton>

export const Reject: React.FC<IconProps> = ({ active = false, onClick, title }) => 
    <TrackedButton event='Reject' onClick={onClick} ><i className={`fas fa-ban ${active ? selected : notSelected}`} title={title}></i></TrackedButton>
